import JwtService from '@/services/jwt.service'
import axios from '@/plugins/axios'

export default class EdExApiService {
  constructor() {
    this.setAuthHeader()
  }

  setAuthHeader() {
    const token = JwtService.getToken()
    axios.defaults.headers.common[import.meta.env.VITE_TOKEN_HEADER_KEY] = token ? `Bearer ${token}` : ''
  }

  async getArticles() {
    const { data } = await axios.get('/v1/api_admin/articles')
    return data
  }

  async getCounters() {
    const { data } = await axios.get('/v1/api_admin/counters')
    return data
  }

  async getArticle(articleId) {
    const { data } = await axios.get('/v1/api_admin/articles/' + articleId)
    return data
  }

  async articleCreate(params) {
    const { data } = await axios.post('/v1/api_admin/articles/create', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  }

  async articleUpdate(params) {
    const { data } = await axios.post('/v1/api_admin/articles/update', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  }

    async articleUpdateSeo(params) {
        const { data } = await axios.post('/v1/api_admin/articles/update_seo', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        return data
    }

  async articleRemove(articleId) {
    const { data } = await axios.post('/v1/api_admin/articles/remove/' + articleId)
    return data
  }

  async getGuides() {
    const { data } = await axios.get('/v1/api_admin/guides')
    return data
  }

  async getGuide(guideId) {
    const { data } = await axios.get('/v1/api_admin/guides/' + guideId)
    return data
  }

  async uploadTiptapContentImage(file) {
    const formData = new FormData()
    formData.append('image', file)
    const { data } = await axios.post('/v1/api_admin/tiptap/upload_content_image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  }

  async guideCreate(params) {
    const {data} = await axios.post('/v1/api_admin/guides/create', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  }

  async guideUpdate(params) {
    const { data } = await axios.post('/v1/api_admin/guides/update', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  }

  async guideUpdateSeo(params) {
    const { data } = await axios.post('/v1/api_admin/guides/update_seo', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  }

  async guideRemove(guideId) {
    const { data } = await axios.post('/v1/api_admin/guides/remove/' + guideId)
    return data
  }

  async getInstitutions(fields) {
    if (this.abortController) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    const signal = this.abortController.signal
    const { data } = await axios.get('/v1/api_admin/institutions', { signal, params: fields })
    return data
  }

  async getInstitution(institutionId) {
    const { data } = await axios.get('/v1/api_admin/institutions/' + institutionId)
    return data
  }

  async searchInstitutions(search) {
    if (!search || String(search).trim() === '') {
      return []
    }
    const { data } = await axios.get('/v1/api_admin/institution/search/' + encodeURIComponent(search.trim()))
    return data
  }

  async deleteInstitution(institutionId) {
    const { data } = await axios.delete('/v1/api_admin/institutions/' + institutionId)
    return data
  }

  async getCountries() {
    const { data } = await axios.get('/v1/api_admin/directory/countries')
    return data
  }

  async getCountry(countryId) {
    const { data } = await axios.get(`/v1/api_admin/directory/countries/${countryId}`)
    return data
  }

  async getCitesByCountryId(countryId) {
    const { data } = await axios.get(`/v1/api_admin/directory/countries/${countryId}/cities`)
    return data
  }

    async getCitesByCountryIdAndRegionId(countryId, regionId) {
        const { data } = await axios.get(`/v1/api_admin/directory/countries/${countryId}/${regionId}/cities`)
        return data
    }

  async getRegionsByCountryId(countryId) {
    const { data } = await axios.get(`/v1/api_admin/directory/countries/${countryId}/regions`)
    return data
  }

  async getRegionByCountryId(countryId, regionId) {
    const { data } = await axios.get(`/v1/api_admin/directory/countries/${countryId}/region/${regionId}`)
    return data
  }

  async getLaguages() {
    const { data } = await axios.get('/v1/api_admin/directory/institution_languages')
    return data
  }

  async getStudytypes() {
    const { data } = await axios.get('/v1/api_admin/directory/studytypes')
    return data
  }

  async getEvents() {
    const { data } = await axios.get('/v1/api_admin/directory/events')
    return data
  }

  async getOrgtypes() {
    const { data } = await axios.get('/v1/api_admin/directory/orgtypes')
    return data
  }

  async getInstitutionTags() {
    const { data } = await axios.get('/v1/api_admin/directory/institutions_tags')
    return data
  }

  async getPopularSubjects() {
    if (this.abortController) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    const signal = this.abortController.signal
    const { data } = await axios.get('/v1/api_admin/directory/subjects/popular', { signal })
    return data
  }

  async searchSubject(name) {
    if (this.abortController) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    const signal = this.abortController.signal

    const { data } = await axios.get('/v1/api_admin/directory/subjects/search/' + name, { signal })
    return data
  }

  async createInstitution(params) {
    const { data } = await axios.post('/v1/api_admin/institution', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  }


    async getContactInfo(institutionId) {
        const { data } = await axios.get('/v1/api_admin/institution/contact_info', { params: {institution_id: institutionId} })
        return data
    }

    async saveContactInfo(params) {
        const { data } = await axios.post('/v1/api_admin/institution/contact_info', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        return data
    }

  async updateInstitution(institutionId, params) {
    const { data } = await axios.post('/v1/api_admin/institution/update', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  }

  async updateInstitutionSEO(institutionId, params) {
    const { data } = await axios.post('/v1/api_admin/institution/update_seo', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
     },
    })
    return data
  }

  async getPopularPrograms() {
    if (this.abortController) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    const signal = this.abortController.signal
    const { data } = await axios.get('/v1/api_admin/directory/programs/popular', { signal })
    return data
  }

  async searchProgram(name) {
    if (this.abortController) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    const signal = this.abortController.signal

    const { data } = await axios.get('/v1/api_admin/directory/programs/search/' + name, { signal })
    return data
  }

  async translate(params) {
    const { data } = await axios.post('/v1/api_admin/translate', params)
    return data
  }
  async getWorkflowReviews() {
    const { data } = await axios.get('/v1/api_admin/workflow/reviews')
    return data
  }

  async getReviews() {
    const { data } = await axios.get('/v1/api_admin/reviews')
    return data
  }

  async getReview(reviewId) {
    const { data } = await axios.get('/v1/api_admin/reviews/' + reviewId)
    return data
  }

  async getReviewResponse(reviewId, params) {
    const { data } = await axios.post('/v1/api_admin/reviews/' + reviewId + '/response', params)
    return data
  }
  async reviewApprove(reviewId, params) {
    const { data } = await axios.post('/v1/api_admin/reviews/' + reviewId + '/approve', params)
    return data
  }
  async reviewReject(reviewId, params) {
    const { data } = await axios.post('/v1/api_admin/reviews/' + reviewId + '/reject', params)
    return data
  }

  async getTutors() {
    const { data } = await axios.get('/v1/api_admin/tutors')
    return data
  }

  async getTutor(tutorId) {
    const { data } = await axios.get('/v1/api_admin/tutors/' + tutorId)
    return data
  }

  async getWorkflowTutors() {
    const { data } = await axios.get('/v1/api_admin/workflow/tutors')
    return data
  }

  async tutorApprove(tutorId) {
    const { data } = await axios.post('/v1/api_admin/tutors/' + tutorId + '/approve')
    return data
  }

  async tutorReject(tutorId, params) {
    const { data } = await axios.post('/v1/api_admin/tutors/' + tutorId + '/reject', params)
    return data
  }

  async getCatalog() {
    const { data } = await axios.get('/v1/api_admin/catalog')
    return data
  }

  async getCatalogOrgtype(orgtypeId) {
    const { data } = await axios.get('/v1/api_admin/catalog/' + orgtypeId)
    return data
  }

  async getCatalogCountry(orgtypeId, countryId) {
    const { data } = await axios.get('/v1/api_admin/catalog/' + orgtypeId + '/' + countryId)
    return data
  }

    async getCatalogRegion(orgtypeId, countryId, regionId) {
        const { data } = await axios.get('/v1/api_admin/catalog/' + orgtypeId + '/' + countryId + '/region/' + regionId)
        return data
    }

    async getCatalogCity(orgtypeId, countryId, regionId, cityId) {
        const { data } = await axios.get('/v1/api_admin/catalog/' + orgtypeId + '/' + countryId + '/region/' + regionId + '/city/' + cityId)
        return data
    }

  async saveCatalogMeta(params) {
     const { data } = await axios.post('/v1/api_admin/catalog/save_meta', params)
     return data
  }

  async updateGuidesOrder(params) {
    const { data } = await axios.patch('/v1/api_admin/guides/order', params)
    return data
  }

  async updateKeyWords(country_id, params) {
    const { data } = await axios.put('/v1/api_admin/directory/countries/'+country_id+'/keywords', {keywords: params})
    return data
  }

  async getActiveKeywords(country_id) {
    const { data } = await axios.get('/v1/api_admin/directory/countries/'+country_id+'/keywords/active')
    return data
  }

  async getKeywords(country_id) {
    const { data } = await axios.get('/v1/api_admin/directory/countries/'+country_id+'/keywords')
    return data
  }

  async getCitesByCountryId(countryId) {
    const { data } = await axios.get(`/v1/api_admin/directory/countries/${countryId}/cities`)
    return data
  }

  async getAllUsers() {
    const { data } = await axios.get(`/v1/api_admin/users`)
    return data
  }

  async getRequests() {
    const { data } = await axios.get(`/v1/api_admin/requests`)
    return data
  }

  async getTutorRequestSends(params = {}) {
    const { data } = await axios.get('/v1/api_admin/tutor_request_sends', { params })
    return data
  }

  async getTutorRequestSend(sendId) {
    const { data } = await axios.get('/v1/api_admin/tutor_request_sends/' + sendId)
    return data
  }

  async getRequest(requestId) {
    const { data } = await axios.get('/v1/api_admin/requests/' + requestId)
    return data
  }

  async getPartnershipsRequests() {
    const { data } = await axios.get(`/v1/api_admin/partnerships_requests`)
    return data
  }
  async onlineConsultationSaveTemplate(params) {
    const { data } = await axios.post('/v1/api_admin/online_consultation/save_template', params)
    return data
  }

  async onlineConsultationGetTemplate(dayStart, dayEnd, timezone) {
    const { data } = await axios.get('/v1/api_admin/online_consultation/get_availability_templates?dayStart=' + dayStart + '&dayEnd=' + dayEnd + '&timezone=' + timezone)
    return data
  }

  async onlineConsultationGetBookingSlots(dayStart, dayEnd, timezone) {
    const { data } = await axios.get('/v1/api_admin/online_consultation/get_booking_slots?dayStart=' + dayStart + '&dayEnd=' + dayEnd + '&timezone=' + timezone)
    return data
  }

    async onlineConsultationBookingSlots(params) {
        const { data } = await axios.post('/v1/api_admin/online_consultation/book_slot', params)
        return data
    }

    async getApplicationForms() {
        const { data } = await axios.get('/v1/api_admin/application_forms')
        return data
    }

    async getApplicationForm(applicationFormId) {
        const { data } = await axios.get('/v1/api_admin/application_forms/' + applicationFormId)
        return data
    }

    async applicationFormApprove(applicationFormId) {
        const { data } = await axios.post('/v1/api_admin/application_forms/' + applicationFormId + '/approve')
        return data
    }

    async applicationFormReject(applicationFormId, params) {
        const { data } = await axios.post('/v1/api_admin/application_forms/' + applicationFormId + '/reject', params)
        return data
    }

  async getInstitutionsAds(status) {
    if (this.abortController) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    const signal = this.abortController.signal
    const { data } = await axios.get('/v1/api_admin/institution_ads', {
      signal,
      params: status ? { status } : {},
    })
    return data
  }

  async getInstitutionsAd(adId) {
    const { data } = await axios.get('/v1/api_admin/institution_ads/' + adId)
    return data
  }

   async institutionAdCreate(params) {
    const { data } = await axios.post('/v1/api_admin/institution_ads/create', params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
    return data
  }
    async institutionAdUpdate(params) {
        const { data } = await axios.post('/v1/api_admin/institution_ads/update', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        return data
    }

    async institutionAdPause(institutionId) {
        const { data } = await axios.get('/v1/api_admin/institution_ads/pause/' + institutionId)
        return data
    }

    async institutionAdResume(institutionId) {
        const { data } = await axios.get('/v1/api_admin/institution_ads/resume/' + institutionId)
        return data
    }
    async institutionAdRemove(institutionId) {
        const { data } = await axios.get('/v1/api_admin/institution_ads/remove/' + institutionId)
        return data
    }

  async getInvoiceOffers() {
    const { data } = await axios.get('/v1/api_admin/invoice_offers')
    return data
  }

  async getInvoiceOffer(invoiceOfferId) {
    const { data } = await axios.get('/v1/api_admin/invoice_offers/' + invoiceOfferId)
    return data
  }

  async invoiceOfferCreate(params) {
    const { data } = await axios.post('/v1/api_admin/invoice_offers/create', params)
    return data
  }

  async invoiceOfferUpdate(params) {
    const { data } = await axios.post('/v1/api_admin/invoice_offers/update', params)
    return data
  }

}
